import { ImgHTMLAttributes } from 'react';

import NextImage from 'next/image';

// This approach is used to avoid bundling unnecessary code
// when building both Vite and Next.js apps.
const ComponentImage: any =
  process.env.VITE_APP_ENV !== 'true' || process.env.NEXT_PUBLIC_APP_ENV === 'nextjs'
    ? NextImage
    : 'img';

export type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  fill?: boolean;
  priority?: boolean;
  unoptimized?: boolean;
};

export function Image({ priority, ...props }: ImageProps) {
  const nextImageProps = process.env.NEXT_PUBLIC_APP_ENV === 'nextjs' ? { priority } : {};

  return <ComponentImage {...props} {...nextImageProps} />;
}
